import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, HostListener } from '@angular/core';
import { Observable } from 'rxjs';
import { SharedService } from 'src/app/core/services/shared.service';
import { CampoComponent } from 'src/app/shared/ui/campo/campo.component';
import Swal from 'sweetalert2';
import { EventService } from 'src/app/core/services/event.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  // bread crumb items
  breadCrumbItems: Array<{}>;
  data;
  values: object[] = [];
  json = "";
  active = 1;
  navspantalla: string = '';
  estilonavs: string = '';
  strTituloPantallaModal: string = '';

  modalData: any;
  arrWizardLlaves: Array<string> = [];
  alturaSidebar = 'auto';
  isCollapsed = false;
  tabsCollapsed = true;
  copiallaves: Array<any> = [];
  LlavesP: Array<string> = [];

  @Input() SYS02CON: number;
  @Input() encabezado = [];
  @Input() form_template: Observable<any>;
  @Input() Navs: Observable<any>;
  @Input() ToolbarMS: Observable<any>;
  @Input() strListener: string = '';
  @Input() EventoCerrarMSNavID: string = '';
  @Input() SYS02JAV: string = "";
  @Input() FormID: string = "";
  @Input() titulo: string = "";
  @Input() sidebar = "";
  @Input() Reportes: any;
  @Input() strModoCampo: any;
  @Input() WsLlaves: any = '';
  @Input() AccionesOnChange = [];
  @Input() SYS41ARC = [];

  @Input() tipoPantalla = "Stepper";
  navsData: any[] = [];
  showFloatingPanel: boolean = false;

  @Output() AbrirNuevoNav = new EventEmitter<string>();
  @Output() EventoCerrarMsInterno = new EventEmitter<boolean>();

  @ViewChild(CampoComponent) child: CampoComponent;
  @ViewChild('wiz') wiz: ElementRef;

  @ViewChild('floatingPanel') floatingPanel: ElementRef;
  @ViewChild('ellipsisBtn') ellipsisBtn: ElementRef;

  CNT05DES: string;
  M05DES: string;
  toolbarMSArray: any[] = [];
  botonesVisibles: any[] = [];
  botonesDropdown: any[] = [];
  botonesReportes: any[] = [];
  botonesProcesos: any[] = [];

  constructor(private dataService: SharedService,
    private eventService: EventService,
    private modalService: NgbModal) { }

  ngOnInit(): void {

    this.breadCrumbItems = [{ label: 'Forms' }, { label: 'Form Wizard', active: true }];
    this.data = this.form_template;

    this.CNT05DES = localStorage.getItem("X-AVATAR-CNT05DES");
    this.M05DES = localStorage.getItem("X-AVATAR-M05DES");

    this.navspantalla = this.eventService.pantalla();
    if (this.navspantalla == undefined) {
      this.navspantalla = "horizontal";
    }

    var es_chrome = navigator.userAgent.toLowerCase().indexOf('chrome') > -1;
    if (es_chrome) {
      if (this.navspantalla === "vertical") {
        this.estilonavs = 'vertical2'
      } else if (this.navspantalla === "horizontal") {
        this.estilonavs = 'horizontal2'
      } else {
        this.estilonavs = 'vertical2'
      }
    }

    var es_firefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
    if (es_firefox) {
      if (this.navspantalla === "vertical") {
        this.estilonavs = 'vertical'
      } else if (this.navspantalla === "horizontal") {
        this.estilonavs = 'horizontal'
      } else {
        this.estilonavs = 'vertical'
      }
    }

    if (this.ToolbarMS && typeof this.ToolbarMS.subscribe === 'function') {
      this.ToolbarMS.subscribe(botones => {
        this.procesarBotones(botones);
      });
    } else if (Array.isArray(this.ToolbarMS)) {
      this.procesarBotones(this.ToolbarMS);
    }

    if (this.Navs && typeof this.Navs.subscribe === 'function') {
      this.Navs.subscribe((v: any) => {
        this.navsData = Array.isArray(v) ? v : (v || []);
      });
    } else {
      this.navsData = Array.isArray(this.Navs) ? this.Navs : [];
    }

  }

  isStepper(): boolean {
    return (this.tipoPantalla || 'stepper').toString().toLowerCase() === '';
  }

  getStepClass(num: number): string {
    const stepId = num + 1;
    if (this.active === stepId) return 'step-card step-active';
    if (this.active > stepId) return 'step-card step-completed';
    return 'step-card';
  }

  getStepNormalClass(num: number): string {
    const stepId = num + 1;
    if (this.active === stepId) return 'step-card step-active';
    if (this.active > stepId) return 'step-card';
    return 'step-card';
  }

  onStepperClick(num: number) {
    const id = num + 1;
    this.active = id;
  
    const limit = this.getLimit();
    if (num < limit) {
      this.showFloatingPanel = false;
    }
  }

  procesarBotones(botones: any[]) {
    this.toolbarMSArray = botones;
  
    this.botonesVisibles = botones.filter(btn =>
      btn.SYS16ESP !== 'S'
    );
  
    this.botonesReportes = botones.filter(btn =>
      btn.Evento === 'IMPRIMIR' && btn.SYS16ESP === 'S'
    );
  
    this.botonesProcesos = botones.filter(btn =>
      btn.Evento !== 'IMPRIMIR' && btn.SYS16ESP === 'S'
    );
  }

  abrirSelectorFormato(boton: any) {
    Swal.fire({
      title: '¿Qué formato deseas?',
      icon: 'question',
      html: `
        <div style="display: flex; justify-content: center; gap: 10px; margin-top: 20px;">
          <button id="btnPdf" class="swal2-confirm swal2-styled" style="background-color: #d32f2f;">
            <i class="fas fa-file-pdf"></i> PDF
          </button>
          <button id="btnExcel" class="swal2-cancel swal2-styled" style="background-color: #388e3c;">
            <i class="fas fa-file-excel"></i> Excel
          </button>
        </div>
      `,
      showConfirmButton: false,
      showCancelButton: false,
      showCloseButton: false,
      didOpen: () => {
        const btnPdf = document.getElementById('btnPdf');
        const btnExcel = document.getElementById('btnExcel');

        if (btnPdf) {
          btnPdf.addEventListener('click', () => {
            Swal.close();
            this.EventoClickMS(null, boton.URL, boton.Evento, null, boton, 'PDF');
          });
        }

        if (btnExcel) {
          btnExcel.addEventListener('click', () => {
            Swal.close();
            this.EventoClickMS(null, boton.URL, boton.Evento, null, boton, 'XLS');
          });
        }
      }
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.alturaSidebar = this.wiz.nativeElement.offsetHeight + 'px';
    }, 1000);

  }

  retornaObservable(form_template) {
    const obs$ = new Observable(observer => {
      observer.next(form_template);
    });
    return obs$;
  }

  FiltrarTabla(event) {
  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }

      if (Array.isArray(form[key])) {
        if (form[key].length > 0) {
          if (form[key][0].base64 == null) {
            form[key] = "'" + form[key].join("','") + "'";
          }
        } else {
          form[key] = "";
        }
      }

      if (form[key] == Number(form[key])) {
        form[key] = String(form[key]);
      }
      if (form[key] == "true" || form[key] == "false") {
        for (const i in this.form_template) {
          for (const j in this.form_template[i].cards) {
            if (this.form_template[i].cards[j].label == key) {
              if (form[key] == "true") {
                form[key] = this.form_template[i].cards[j].CheckBoxTrue;
              } else if (form[key] == "false") {
                form[key] = this.form_template[i].cards[j].CheckBoxFalse;
              }
              break;
            }
          }
        }
      }
    }

    return form;
  }

  ValidarWizard(): boolean {
    let blnOK = true;
  
    try {
      // Si no hay child en este tab, no hay nada que validar -> asumimos válido
      if (!this.child) {
        return true;
      }
  
      const form = (this.child as any).myFormGroup;
      // Si el child no expone myFormGroup (p. ej. es una tabla, reporte, etc.), consideramos válido
      if (!form) {
        return true;
      }
  
      if (form.valid) {
        // Copias defensivas para evitar mutaciones inesperadas
        const cop = (this.child as any).copiallaves && (this.child as any).copiallaves.length
          ? (this.child as any).copiallaves[0]
          : {};
  
        this.copiallaves = this.formatearFormulario(JSON.parse(JSON.stringify(cop)));
        this.LlavesP = this.formatearFormulario(JSON.parse(JSON.stringify(form.value)));
        const objForm = this.formatearFormulario(JSON.parse(JSON.stringify(form.value)));
  
        // Mantener el arreglo alineado por step (evita duplicados y desorden)
        const stepIndex = Math.max(0, (this.active || 1) - 1);
        this.arrWizardLlaves[stepIndex] = objForm;
      } else {
        blnOK = false;
        Swal.fire({
          title: 'Error',
          text: 'Debe completar todos los campos obligatorios para poder continuar.',
          icon: 'error',
        });
      }
    } catch (error) {
      console.error('ValidarWizard error:', error);
      blnOK = false;
      Swal.fire({
        title: 'Error',
        text: 'Ocurrió un error al validar. Por favor revise los datos e intente nuevamente.',
        icon: 'error',
      });
    }
  
    return blnOK;
  }

  AbrirNuevoNavInterno(strData: string) {
    this.AbrirNuevoNav.emit(strData);
  }

  toJSON(operacion: string, arr: any[], url?: string) {
    return JSON.parse("{ \"LLAVES\"   :" + JSON.stringify(arr) +
      (url != null ? (", \"URL\"      :\"" + url + "\"") : "") +
      ", \"OPERACION\":\"" + operacion + "\"}");
  }

  AbrirModalUpload(evento, contenido, url_modal: string) {
    if (this.ValidarWizard()) {
      var jsonFiltros = this.toJSON(evento, this.arrWizardLlaves, url_modal);
      this.dataService.ConsultarWS(url_modal, jsonFiltros).subscribe(
        (datosResp: any) => {
          this.modalData = datosResp.DATA;
          this.strTituloPantallaModal = 'Cargar Fotografía';
          this.modalService.open(contenido, { size: 'xl' });
        },
        error => {
          Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
          })
        }
      );
    }
  }

  RetornoModal(event) {
    alert('poner acá refresh de la foto, falta');
    this.modalService.dismissAll();
  }

  EventoClickMS(obj, url, evento, contenido, boton, formato) {
    const btn = document.getElementById("campo2_" + evento) as HTMLButtonElement
    if (evento == "EVENTO_CERRAR") {
      // Cierro el Tab Actual
      this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));
      this.CerrarMsInternoClick(false);
    } else if (evento == "UPLOAD_FILE") {
      this.AbrirModalUpload(evento, contenido, url);
    } else if (evento == "IMPRIMIR" || evento == "IMPRIMIR_FIRMAR") {
      this.VerReporte(this.SYS02CON, boton.SYS10CON, boton.SYS16CON, formato, url, evento)
    } else if (evento == "IMPRIMIR_PERSONAL") {
      this.VerReportePersonalizado(this.SYS02CON, boton.SYS44COD, "PDF", url, evento)
    } else {
      let jsonFiltros;
      if (evento == "DELETE_GENERICO" || evento == "DELETE_WS" || evento == "ANULAR") {
        let objForm = this.formatearFormulario(this.child.myFormGroup.value);
        this.arrWizardLlaves.push(objForm);
        jsonFiltros = this.toJSON(evento, this.arrWizardLlaves, url);
        var mensaje = "Está seguro de Eliminar?";
        if (evento == "ANULAR") mensaje = "Está seguro de anular?";

        Swal.fire({
          title: mensaje,
          text: "No podrás revertir esto!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          cancelButtonText: 'No, cancelar!',
          confirmButtonText: evento == "ANULAR" ? 'Si, anularlo' : 'Si, eliminarlo',
        }).then((result) => {
          if (result.isConfirmed) {
            this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
              (datosResp: any) => {

                // Todo bien, refresco la lista asociada
                this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + this.strListener, JSON.parse('{}'));

                // Cierro el Tab Actual
                this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));

                this.CerrarMsInternoClick(false);
                Swal.fire({
                  toast: true,
                  position: 'bottom-end',
                  icon: 'success',
                  text: 'Campo Eliminado Correctamente',
                  showConfirmButton: false,
                  timer: 3000
                });
              },
              error => {
                Swal.fire({
                  html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-4">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    '</div>' +
                    ' <div class="col-8">' +
                    '<h3>Error</h3><br>' +
                    ' <p>' + error + '</p>' +
                    ' </div> ',
                })
              }
            );
          }
        })
      } else {
        if (this.ValidarWizard()) {
          // Ejecuto la operacion en el backend
          jsonFiltros = this.toJSON(evento, this.arrWizardLlaves, url);
          let comparacion = JSON.stringify(this.copiallaves) === JSON.stringify(this.LlavesP);
          if (evento != "UPDATE_GENERICO" && evento != 'UPDATE_WS') comparacion = false;
          if (comparacion == false) {
            var operacion = "";
            if (evento == "INSERT_GENERICO") operacion = "Campo Insertado";
            else if (evento == "UPDATE_GENERICO" || evento == "UPDATE_WS") operacion = "Campo Actualizado"
            else if (evento == "DELETE_GENERICO") operacion = "Eliminado";

            this.dataService.ConsultarWS(url, jsonFiltros, btn).subscribe(
              (datosResp: any) => {

                if (datosResp?.base64 != null) {
                  const blob = this.dataURItoBlob(datosResp.base64, datosResp.tipo);
                  let fileURL = URL.createObjectURL(blob);
                  if (datosResp.tipo == 'application/pdf') {
                    window.open(fileURL, '_blank');
                  } else {
                    let link = document.createElement('a');
                    if (datosResp.nombre != null) {
                      link.download = datosResp.nombre;
                    } else {
                      let tipoPartes = datosResp.tipo.split('/');
                      if (tipoPartes.length > 1) {
                        link.download = 'documento.' + tipoPartes[1];
                      } else {
                        link.download = 'documento';
                      }
                    }
                    link.href = fileURL;
                    link.click();
                  }
                }

                // Todo bien, refresco la lista asociada
                this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + this.strListener, JSON.parse('{}'));

                // Cierro el Tab Actual
                this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));

                this.CerrarMsInternoClick(false);
                Swal.fire({
                  toast: true,
                  position: 'bottom-end',
                  icon: 'success',
                  text: operacion + ' Correctamente',
                  showConfirmButton: false,
                  timer: 3000
                });
              },
              error => {
                Swal.fire({
                  html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-4">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    '</div>' +
                    ' <div class="col-8">' +
                    '<h3>Error</h3><br>' +
                    ' <p>' + error + '</p>' +
                    ' </div> ',
                })
              }
            );
          } else {
            if (evento == "UPDATE_GENERICO" || evento == "UPDATE_WS") {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Error</h3><br>" +
                  " <p>No se han encontrado cambios</p>" +
                  " </div> ",
              });
            }
          }
        } else {
          const invalid = [];
          const controls = this.child.myFormGroup.controls;
          for (const name in controls) {
            if (controls[name].invalid) {
              invalid.push(name);
            }
          }
          this.form_template.forEach((input_template) => {
            for (let i = 0; i < input_template.cards.length; i++) {
              for (let j = 0; j < invalid.length; j++) {
                if (invalid[j] == input_template.cards[i].label) {
                  invalid[j] = input_template.cards[i].title;
                }
              }
            }
          });
          Swal.fire({
            html: '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-4">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              '</div>' +
              ' <div class="col-8">' +
              '<h3>Error</h3><br>' +
              ' <p>Por favor verifique los campos requeridos. </p>' +
              "<p>" +
              invalid.join(", ") +
              "</p>" +
              ' </div> ',
          })
        }
      }

    }
    this.arrWizardLlaves = []
  }

  CerrarMsInternoClick(blnRefrescar: boolean) {
    this.EventoCerrarMsInterno.emit(blnRefrescar);
  }

  CerrarMantenimiento(){
    // Todo bien, refresco la lista asociada
    this.eventService.broadcast('EVENTO_REFRESAR_LISTA_' + this.strListener, JSON.parse('{}'));

    // Cierro el Tab Actual
    this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse('{}'));

    this.EventoCerrarMsInterno.emit(true);
  }

  toggleSidebar(estado: boolean) {
    this.isCollapsed = estado;
  }

  cerrarWizard() {
    this.eventService.broadcast("EVENTO_REFRESAR_LISTA_" + this.SYS02CON, JSON.parse("{}"));
    this.eventService.broadcast("EventoCerrarMS_" + this.EventoCerrarMSNavID, JSON.parse("{}"));
    this.CerrarMsInternoClick(false);
  }

  tabChange(event) {
    if (event.nextId == 0) {
      event.preventDefault();
      this.tabsCollapsed = !this.tabsCollapsed;
    } else {
      setTimeout(() => {
        this.alturaSidebar = this.wiz.nativeElement.offsetHeight + 'px';
      }, 3000);
    }
  }

  VerReporte(intSYS02CON: number, intSYS10CON: string, strSYS16CON: string, strFORMATO: string, url: string, evento: string) {
    url = (url == undefined ? "api/mantenimientos/VerReporte/" + intSYS02CON : url);
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS10CON\"   : " + intSYS10CON +
      " , \"SYS16CON\"   : " + strSYS16CON +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(this.formatearFormulario(this.child.myFormGroup.value)) + "]}";
    let arr = JSON.parse(strjson);
    let json = this.toJSON(evento, arr, url + "/" + intSYS10CON + "/" + strSYS16CON);
    this.dataService.ConsultarWS(url + "/" + intSYS10CON + '/' + strSYS16CON, json).subscribe(
      (datosResp: any) => {
        if (evento == 'IMPRIMIR') {
          const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
          const blob = this.dataURItoBlob(base64, strFORMATO);
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        }
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }
  
  VerReportePersonalizado(intSYS02CON: number, intSYS44COD:  string, strFORMATO: string, url: string, evento: string) {
    url = (url == undefined ? "api/mantenimientos/VerReporte/" + intSYS02CON : url);
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS44COD\"   : \"" + intSYS44COD + "\" " +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_DASHBOARD\"    : [] " +       
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(this.formatearFormulario(this.child.myFormGroup.value)) + "]}";
    let arr = JSON.parse(strjson);
    let json = this.toJSON(evento, arr, url + "/" + intSYS44COD );
    this.dataService.ConsultarWS(url + "/" + intSYS44COD , json).subscribe(
      (datosResp: any) => {
        if (evento == 'IMPRIMIR_PERSONAL') {
          const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
          const blob = this.dataURItoBlob(base64, strFORMATO);
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        }
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }

  dataURItoBlob(dataURI, strFORMATO) {
    let strType = "application/pdf";
    if (strFORMATO == "XLS") strType = "application/vnd.ms-excel";
    if (strFORMATO == "SQL") strType = "application/octet-stream";
    if (strFORMATO == "TXT") strType = "text/plain";
    if (strFORMATO == "XML") strType = "application/xml";
    if (strFORMATO == "ZIP") strType = "application/zip";

    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

  getIcono(item){
    let iconFas = item.icono;
    switch (item.casilla) {
      case "General":
        iconFas = "fa-rectangle-list";
        break;
      case "Autorizaciones":
        iconFas = "fa-thumbs-up";
        break;
      case "Documentos":
        iconFas = "fa-folder";
        break;
      case "Gantt":
        iconFas = "fa-chart-gantt";
        break;
    }

    return iconFas;
  }

  GenerarJSONMantenimiento (item) {
    let NavID = (Date.now().toString(36) + Math.random().toString(36).substr(2, 5)).toUpperCase();
    return JSON.parse("{ \"LLAVES\"   :" + JSON.stringify(item.Llaves) +
      ", \"URL\"      : \"" + item.url + "\"" +
      ", \"NAV_ID\"   : \"" + NavID    + "\"" +
      ", \"OPERACION\": \"SELECT\"}");
  }

  toggleFloatingPanel(event?: MouseEvent) {
    if (event) {
      event.stopPropagation(); 
    }
    this.showFloatingPanel = !this.showFloatingPanel;
  }

  closeFloatingPanel() {
    this.showFloatingPanel = false;
  }

  onFloatingTabClick(idx: number) {
    const limit = this.getLimit();
    
    if (idx < limit) {
      this.onStepperClick(idx);
      return;
    }
  
    const visibleIndex = limit - 1; 
    // swap
    const tmp = this.navsData[visibleIndex];
    this.navsData[visibleIndex] = this.navsData[idx];
    this.navsData[idx] = tmp;
  
    this.active = visibleIndex + 1;
  
    this.showFloatingPanel = false;
  }

  avanzarStep() {
    // 1. Solo validamos si 'child' existe. Si no existe, dejamos pasar.
    if (this.child) {
      if (!this.ValidarWizard()) return;
    }

    const limit = this.getLimit();
    // 2. Avanzamos al siguiente tab
    if (this.active < (this.navsData?.length || 0) + 1) {
      this.active++;
    }
  }
  
  retrocederStep() {
    if (this.active > 1) {
      this.active--;
    }
  }

  private getLimit(): number {
    return this.isStepper() ? 8 : 13;
  }
}
